import { useRef, forwardRef, useImperativeHandle } from "react";
import "./FormatterPanel.css";
import { Row } from "react-bootstrap";

const FormatterPanel = forwardRef(
  (
    {
      title,
      value = "",
      onChange,
      placeholder = "",
      isInputDpropdown = false,
      inputdropdown,
      lineCount,
      collapsed,
      headerButtons,
      footerLeft = "Characters : 0",
      footerRight = "Size: 0B",
      readOnly = false,
      showValidateButton = false,
      onValidate,
      customContent,
      panelStyle,
      panelClass,
      wrap = true,
      editorContainerStyle,
    },
    ref
  ) => {
    const textareaRef = useRef(null);
    const lineNumbersRef = useRef(null);

    useImperativeHandle(ref, () => ({
      get textarea() {
        return textareaRef.current;
      },
    }));

    const handleScroll = () => {
      if (lineNumbersRef.current && textareaRef.current) {
        lineNumbersRef.current.scrollTop = textareaRef.current.scrollTop;
      }
    };
    const getVisualLineCount = () => {
      if (!textareaRef.current) return 1;

      const textarea = textareaRef.current;
      const styles = window.getComputedStyle(textarea);

      const lineHeight = parseInt(styles.lineHeight, 10);
      const padding =
        parseInt(styles.paddingTop, 10) +
        parseInt(styles.paddingBottom, 10);

      return Math.max(
        1,
        Math.round((textarea.scrollHeight - padding) / lineHeight)
      );
    };

    const lines =
      typeof lineCount === "number"
        ? lineCount
        : getVisualLineCount();

    return (
      <Row className={`formatter-panel editor-space ${panelClass || ""}`}
        style={panelStyle ? panelStyle : { width: "34em" ,minWidth: "100%" }}>
        <div className="editor-header">
          <span>{title}</span>
          {isInputDpropdown ? (
            <div className="editor-buttons">
              {inputdropdown}
            </div>
          ) : null}
          <div className="editor-buttons">{headerButtons}</div>
        </div>
        <div className="editor-container scroll-container" style={editorContainerStyle ? editorContainerStyle : {}}>
          {!customContent && lines !== 0 && <div ref={lineNumbersRef} className="line-numbers" aria-hidden="true">
            {Array.from({ length: lines || 1 }, (_, i) => (
              <div key={i}>{i + 1}</div>
            ))}
          </div>}
          {customContent ? (
            customContent
          ) : (
            <textarea
              ref={textareaRef}
              value={value}
              wrap={wrap ? "soft" : "off"}
              placeholder={placeholder}
              onChange={onChange}
              onScroll={handleScroll}
              className={`json-textarea${wrap ? "" : " nowrap-textarea"}`}
              readOnly={readOnly}
            />
          )}
        </div>
        <div className="editor-footer">
          <span>{footerLeft}</span>
          <span>{footerRight}</span>
          {showValidateButton && (
            <button
              type="button"
              className="editor-validate-button"
              onClick={onValidate}
            >
              Validate
            </button>
          )}
        </div>
      </Row>
    );
  }
);

FormatterPanel.displayName = "FormatterPanel";

export default FormatterPanel;
